import { Button, Form, Input, notification, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import liracrypt from '../../components/Liracrypt/liracrypt';
import ButtonPicker from '../../components/ReportFormGenerator/Button/Button';

const ImageController = ({
    form,
    label,
    name,
    required,
    labelCol,
    errorMessage,
    data,
    rowData,
    placeholder,
    height,
    disabled,
    pname //used for noChange key
}) => {
    const [img, setImg] = useState();
    const [responseImg, setResponseImg] = useState();
    const imgInputRef = useRef();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (data.hasImage) {
            let urlData = { ...data.params };
            if (data.props) {
                urlData[data.props] = rowData[data.props];
            }
            setLoading(true);
            liracrypt.get(data.api, urlData)
                .then(response => {
                    //setImg(response.data.data);
                    setResponseImg(response.data.data);
                    // setIsRespImg(true);
                    form.setFieldsValue({ [name]: 'noChange' });
                    form.setFieldsValue({ [pname]: 'noChange' });
                    setLoading(false);
                })
                .catch(err => {
                    console.error(err);
                    setLoading(false);
                })
        }
    }, []);

    // useEffect(() => {
    //     let val = form.getFieldsValue()[name];
    //     if (val && val !== 'noChange') {
    //         setImg(val);
    //         setResponseImg(null);
    //     } else {
    //         setImg(null);
    //         if (val !== 'noChange') {
    //             setResponseImg(null);
    //         }
    //     }
    // }, [form.getFieldsValue()[name]]);


    const onPaste = (e) => {
        if (e.clipboardData) {
            let items = e.clipboardData.items;
            for (let item of items) {
                if (item.kind === 'file') {
                    var pasteFile = item.getAsFile();
                    console.log(pasteFile);
                    form.setFieldsValue({ [name]: pasteFile });
                    form.setFieldsValue({ [pname]: null });
                    setImg(pasteFile);
                }
            }
        }
    };

    const getClickedImage = (e) => {

        if (e.target.files[0].type.includes('image/')) {
            setImg(e.target.files[0]);
            form.setFieldsValue({ [name]: e.target.files[0] });
            form.setFieldsValue({ [pname]: null });

        } else {
            notification.error({ message: 'Please Select image file only' })
        }
    }

    const uploadImg = (values) => {
        if (typeof (values[name]) === 'string') {
            notification.error({ message: 'Please Select image file only' });
            return;
        }
        let fileType = values[name].type;
        if (!fileType.includes('image/')) {
            notification.error({ message: 'Please Select image file only' });
            return;
        };
        setLoading(true);
        let formData = new FormData();
        Object.keys(values).forEach(x => {
            formData.append(x, values[x]);
        })
        liracrypt.uploadFile('/image/binary', formData)
            .then(res => {

                setResponseImg(res.data.data);
                notification.success({ message: 'Uploaded Successfully' });
                form.resetFields();
                setImg(null);
                imgInputRef.current.value = '';
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                console.log(err);
            });
    };

    const handleDrop = (e) => {
        e.nativeEvent.preventDefault()
        if (!e) return;
        const files = e.nativeEvent.dataTransfer.files;
        if (!files[0]) return;
        if (files[0].type.includes('image/')) {
            form.setFieldsValue({ [name]: files[0] });
            form.setFieldsValue({ [pname]: null });
            setImg(files[0]);
        } else {
            notification.error({ message: 'Please Select image file only' })
        }
    };

    const resetImg = () => {
        form.setFieldsValue({ [name]: null });
        form.setFieldsValue({ [pname]: null });
        imgInputRef.current.value = '';
        setImg(null);
        setResponseImg(null);
    };
    return (
        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
            <Form.Item
                // initialValue={defaultValue}
                name={pname}
                hidden
            >
            </Form.Item>
            <Form.Item
                labelAlign='left'
                name={name}
                labelCol={{ span: labelCol || 8 }}
                className='image-sniper'
                //  label={label}
                style={{ marginRight: "10px", fontWeight: 600 }}
                rules={[
                    {
                        required: required,
                        message: errorMessage,
                    },
                ]}
            >
                {
                    responseImg ? (
                        <div className='uploaded-img'>
                            <div className="img">
                                <img
                                    src={responseImg}
                                />
                            </div>
                            <div className='img-edit-icon' onClick={() => { imgInputRef.current.click() }}>
                                <span>
                                    <EditOutlined className="img-trash" />
                                </span>
                            </div>
                            <div className='img-delete-icon' onClick={resetImg}>
                                <span>
                                    <DeleteOutlined className="img-trash" />
                                </span>
                            </div>
                        </div>
                    ) :
                        img ? (
                            <div className='uploaded-img' onClick={resetImg}>
                                <div className="img">
                                    <img
                                        src={URL.createObjectURL(img)}
                                    />
                                </div>
                                <div className='img-edit-icon' onClick={() => { imgInputRef.current.click() }}>
                                    <span>
                                        <EditOutlined className="img-trash" />
                                    </span>
                                </div>
                                <div className='img-delete-icon'>
                                    <span>
                                        <DeleteOutlined className="img-trash" />
                                    </span>
                                </div>
                            </div>
                        ) :
                            <div className="img-cntrl-wrapper upload-image">
                                <div className='img-paste-container' onPaste={onPaste} contentEditable onDragOver={e => e.preventDefault()} onDrop={handleDrop} style={{ minHeight: height, pointerEvents: disabled ? 'none' : '' }}>
                                </div>
                                <Button onClick={() => { imgInputRef.current.click() }} type='link' style={{ color: ' #777777' }}>Click To Upload</Button>
                            </div>

                    // <Input
                    //     placeholder={placeholder || 'Paste your image'}
                    //     style={{ backgroundColor: '#ffffff', minHeight: 40 }}
                    //     onPaste={onPaste}
                    //     suffix={
                    //         <div style={{ marginRight: 20 }} onClick={() => { imgInputRef.current.click() }}>
                    //             <span>
                    //                 <EditOutlined className="img-edit" style={{fontSize: 20}} />
                    //             </span>
                    //         </div>
                    //     }
                    // />
                }
            </Form.Item>
            <input className='hidden-input-img' accept='.png, .jpg, .jpeg' ref={imgInputRef} type="file" style={{ visibility: 'hidden', height: '0px !important' }} onChange={getClickedImage} />
        </div >
    )
};

export default ImageController;